'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Plus = require('./Plus');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plus).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Plus/index.js
// module id = 1258
// module chunks = 1